import React, { Component } from 'react';

class AboutTreesome extends Component {
  render() {
    return (
      <section className={this.props.background} id="about">
        <div className="container mt-5 mb-5">
          <div className="row pt-2 pb-2">
            <span className="col-12 txt-bold-40px txt-green txt-uppercase">Restaurant & Bar a tapas</span>
            <p className="col-12 txt-thin">
              C’est entre créativité et inventivité qu’on présente le treesome.
              <br />
              Une histoire simple, sobre et efficace qui passe d’un style à un autre ou d’un univers à l’autre.
              <br />
              Un festival de couleur et de texture à parsemer et à mixer sans modération pour composer
              <br />
              des sous-espaces douillets avec un style très décalé.
              <br />
            </p>
            <p className="col-12 txt-thin">
              The treesome est avant tout un espace de rencontre et de partage entre les différentes catégories qui compose
              <br />
              notre société ; étudiants, fonctionnaires, artistes un mélange social et culturel de tout genre.
              <br />
              Tout comme pour la brochette de service qu’on suggère à nos clientèles.
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutTreesome;



// WEBPACK FOOTER //
// ./src/components/treesome/AboutTreesome.js